// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"c4d256fc","171":"fd2998ad","453":"9258c6bf"}[chunkId] + ".chunk.js";
};